<template>
  <modal
    name="add-financial-eco"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('add-financial-eco')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <!--<flash-message class="fl-msg"></flash-message>-->
      <div class="fl-msg" />

      <div
        v-if="date"
        class="ui-block-title"
      >
        <h6 class="title">
          Financial Economii
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="addRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Date</strong></p>
              <datepicker
                :value="date"
                class="form-group label-floating"
                @selected="dateSelected"
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Category</strong></p>
              <select
                v-model="item.cat_id"
                class="form-group has-bootstrap-select "
              >
                <option :value="''">
                  Choose Category
                </option>
                <option
                  v-for="option in categories"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Description</strong></p>
              <textarea
                v-model="item.description"
                rows="5"
                class="form-control label-floating"
              />
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Amount</strong></p>
              <input
                v-model="item.amount"
                class="form-group label-floating"
              >
            </div>
          </div>

          <button
            class="btn btn-lg btn-breez full-width mt-4"
            type="submit"
            name="submit"
          >
            <span>{{ item.id ? 'Edit' : 'Add' }} Row</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import VModal from 'vue-js-modal';
import Vue from 'vue'
Vue.use(VModal, {dialog: true});
import { mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon"

export default {
  name: 'AddFinancialEco',
  components: { Datepicker, AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      item: {
        cat_id: '',
        description: '',
        amount: ''
      },
      oldItem: {},
      date: new Date()
    }
  },
  computed: mapState({
    categories: state => state.financial.cateco
  }),
  created () {
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
      ? MODAL_HEIGHT - 200
      : MODAL_HEIGHT
  },
  methods: {
    dateSelected (date) {
      this.date = date
    },
    beforeOpen (event) {
      this.$store.dispatch('financial/getCatEco', Vue.prototype.$currentYear)
      if (event.params.item) {
        this.item = event.params.item
        this.oldItem = Object.assign({}, event.params.item)
        this.date = new Date(event.params.item.date)
      }
    },
    // eslint-disable-next-line
      addRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      payload.date = this.date
      if (this.item.id) {
        this.$store.dispatch('financial/editEco', { payload, oldItem: this.oldItem })
      } else {
        this.$store.dispatch('financial/addEco', payload)
      }
    }
  }
}
</script>
